export const USER_AVATAR = "https://avatars.githubusercontent.com/u/105533945?v=4";
export const COVER_IMAGE = "https://assets.nflxext.com/ffe/siteui/vlv3/df6621a3-890c-4ca0-b698-90bd5152f3d1/20a59be7-7062-4991-bca0-805e9a7f2716/IN-en-20240107-trifectadaily-perspective_alpha_website_small.jpg"

export const API_OPTIONS = {
     method: 'GET',
  headers: {
    accept: 'application/json',
    Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI4YmZmMjgzOWVjODZkMmUyOThkZmQ4NzI0Nzg3M2Y2MyIsInN1YiI6IjY1YjRlOWI4NThlZmQzMDE2M2NhMzFiZSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ._ZEDnc1tDHRQM_tGXKUyoI3HnC9X60swoKoQoNsFGOQ'
  }
}

export const IMAGE_CDN_URL = "https://image.tmdb.org/t/p/w500/"